import React from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Section from "../../common/Section";
import Fieldset from "../../common/Fieldset";
import Row from "../../common/Row";
import { BezoekerTabs, BezoekerLabels } from "../../../constants/DomainConstants";
import TabInfoComponent from "./parts/TabInfoComponent";

const BevestigingForm = (props) => {
    const {
        goToFirstTab,
        onDienIn,
        model,
        rechtsvormen,
        sporttakken,
        doelgroepen
    } = props;

    const tabInfo = Object.keys(BezoekerTabs).map((t, i) => {
        return (
            <TabInfoComponent
                tab={BezoekerTabs[t]}
                key={i}
                model={model[Object.keys(model)[i]]}
                rechtsvormen={rechtsvormen}
                sporttakken={sporttakken}
                doelgroepen={doelgroepen}
                labels={BezoekerLabels}
            />
        );
    });

    return (
        <Section>
            <Form
                name="bevestiging"
                headerVisible={false}
                isNotRequired
                leftButtonLabel="Terug naar begin"
                onLeftButtonClick={goToFirstTab}
                rightButtonLabel="Dien in"
                onRightButtonClick={onDienIn}
            >
                <Fieldset>
                    <Row><div style={{ color: "#082b42", fontSize: "1.4375rem", fontWeight: "500", lineHeight: "28px", margin: "30px 0.83333% 0 0.83333%" }}>Bevestig melding nieuwe sportclub</div></Row>
                    <div style={{ width: "100%", height: "1px", backgroundColor: "#E6E6E6", marginTop: "30px" }}></div>
                </Fieldset>
                <Fieldset>
                    <p style={{ color: '#082B42', fontSize: '15px' }}>Kloppen deze gegevens?<br />Kijk ze na en dien onderaan in.</p>
                </Fieldset>
                <Fieldset>
                    {tabInfo}
                </Fieldset>
            </Form>
        </Section>
    );
};

BevestigingForm.propTypes = {
    goToFirstTab: PropTypes.func,
    onDienIn: PropTypes.func,
    model: PropTypes.object,
    rechtsvormen: PropTypes.array,
    sporttakken: PropTypes.array,
    doelgroepen: PropTypes.array
};

export default BevestigingForm;